<i18n src="@/lang/table.json"></i18n>
<i18n src="@/lang/actions.json"></i18n>

<template>
  <el-main>
    <component
      :is="require('../_snippets/header_actions/header_actions').default"
    >
      <template slot="button-group">
        <el-button
          type="primary"
          :disabled="edit_mode"
          @click="handleAddNewVendor"
          >{{ $t("actions.new_vendor") }}
        </el-button>
      </template>
    </component>
    <el-table :data="vendors">
      <el-table-column
        v-for="(v, k) in schema"
        :key="k"
        v-bind="v.props"
        :label="$t('table.' + k)"
        :property="k"
      >
        <template slot-scope="scope">
          <template v-if="v.type === Boolean">
            <el-checkbox
              v-model="scope.row[k]"
              v-if="v.type === Boolean"
              :disabled="scope.row.uuid !== cur_edited"
            />
          </template>
          <template v-else>
            <span
              v-text="scope.row[k]"
              v-if="cur_edited !== scope.row.uuid"
            ></span>
            <el-input
              v-model="scope.row[k]"
              v-else-if="v.editable"
              size="small"
            ></el-input>
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.operations')" align="right">
        <template slot="header" slot-scope="scope">
          <el-input
            :key="scope.index"
            size="mini"
            v-model="filter_string"
            :placeholder="$t('search.placeholder')"
            spa-action="find"
          />
        </template>
        <template slot-scope="scope">
          <el-button-group class="el-button-group-block">
            <template v-for="(v, k) in scope.row.actions">
              <el-button
                :key="k"
                v-if="showBtn(scope.row, v.in_edit_mode, !v.in_submenu)"
                v-bind="v.props"
                :disabled="disableBtn(scope.row.uuid) || v.props.disabled"
                @click="handleAction(v.handler)"
                >{{ $t("actions." + k) }}
              </el-button>
            </template>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import DirectoryVendors from "../../store/classes/DirectoryVendors";

export default {
  name: "vendorsList",
  data() {
    return {
      schema: DirectoryVendors.schema,
      cur_edited: null,
      edit_mode: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapMutations("directory_vendors_list", ["addFirst"]),
    ...mapActions("directory_vendors_list", ["getData"]),
    handleAddNewVendor() {
      this.addFirst();
      this.edit_mode = true;
      this.cur_edited = this.vendors[0].uuid;
    },
    showBtn(v, in_edit_mode, in_submenu) {
      return (
        (this.cur_edited !== v.uuid && !in_edit_mode && in_submenu) ||
        (this.cur_edited === v.uuid && in_edit_mode && in_submenu)
      );
    },
    disableBtn(v) {
      return this.cur_edited !== null && this.cur_edited !== v;
    },
    handleAction(handler) {
      let h = handler();
      let notify;
      if (h instanceof Promise) {
        h.then(param => {
          if (
            /^[0-9a-fA-F]{8}(-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}$/.test(param)
          ) {
            this.cur_edited = param;
          } else {
            switch (param) {
              case "saved":
                notify = {
                  type: "success",
                  title: "Success",
                  message: "Vendor saved"
                };
                this.edit_mode = false;
                if (this.cur_edited === undefined) {
                  this.vendors.push(this.vendors.shift());
                }
                this.cur_edited = null;
                break;
              case "canceled":
                notify = {
                  type: "info",
                  title: "Canceled",
                  message: "Edit canceled"
                };
                this.edit_mode = false;
                this.cur_edited = null;
                break;
              case "deleted":
                notify = {
                  type: "success",
                  title: "Success",
                  message: "Vendor deleted"
                };
                this.getData();
                break;
              default:
                break;
            }
          }
          if (notify) {
            this.$notify(notify);
          }
        }).catch(() => {
          if (this.cur_edited === undefined) {
            this.$notify({
              type: "info",
              title: "Canceled",
              message: "Add new canceled"
            });
            this.vendors.shift();
            this.cur_edited = null;
            this.edit_mode = false;
          }
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      vendors: "directory_vendors_list/vendors"
    }),
    ...mapState("directory_vendors_list", ["filter_string"])
  }
};
</script>

<style scoped></style>
